import { render, staticRenderFns } from "./CMainInfo.vue?vue&type=template&id=41c3d47c&scoped=true&"
import script from "./CMainInfo.vue?vue&type=script&lang=js&"
export * from "./CMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./CMainInfo.vue?vue&type=style&index=0&id=41c3d47c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c3d47c",
  null
  
)

export default component.exports